import { render, staticRenderFns } from "./CompareCompareRow.vue?vue&type=template&id=27a7ce37&"
import script from "./CompareCompareRow.vue?vue&type=script&lang=js&"
export * from "./CompareCompareRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports